__turbopack_context__.v({
  "detailsSection": "Az8tPG_detailsSection",
});
